import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { TableColumnsIcon, Text, Dropdown, Box, FieldContainer, Checkbox } from "@contember/ui";
import { useMemo, Fragment as Fragment$1 } from "react";
function DataGridColumnHiding({
  desiredState,
  formatMessage,
  setIsColumnHidden
}) {
  const buttonProps = useMemo(() => ({
    intent: "default",
    distinction: "seamless",
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(TableColumnsIcon, {}),
      /* @__PURE__ */ jsx(Text, { translate: formatMessage, children: "dataGrid.columnHiding.showMenuButton.text" })
    ] }),
    size: "small"
  }), [formatMessage]);
  return /* @__PURE__ */ jsx(Dropdown, { buttonProps, children: /* @__PURE__ */ jsx(Box, { border: false, label: /* @__PURE__ */ jsx(Text, { translate: formatMessage, children: "dataGrid.columnHiding.heading" }), children: /* @__PURE__ */ jsx("div", { style: { display: "flex", flexDirection: "column", gap: "0.25em" }, children: Array.from(desiredState.columns, ([key, column]) => {
    if (column.canBeHidden === false) {
      return /* @__PURE__ */ jsx(Fragment$1, {}, key);
    }
    return /* @__PURE__ */ jsx(
      FieldContainer,
      {
        display: "inline",
        label: column.header,
        labelPosition: "right",
        children: /* @__PURE__ */ jsx(
          Checkbox,
          {
            notNull: true,
            value: !desiredState.hiddenColumns[key],
            onChange: (isChecked) => setIsColumnHidden(key, !isChecked)
          }
        )
      },
      key
    );
  }) }) }) });
}
export {
  DataGridColumnHiding
};
//# sourceMappingURL=DataGridColumnHiding.js.map
